<template>
  <div>
    <draggable
      v-model="items"
      tag="ul"
      group="treeview-group"
      class="custom-treeview"
      @end="handleUpdate"
    >
      <li v-for="item in items" :key="item.treeViewId">
        <DraggableTreeviewNode
          :item="item"
          @update-tree-structure="handleUpdate"
        >
          <template v-slot:append="{ item: nodeItem }">
            <slot name="append" :item="nodeItem"></slot>
          </template>
        </DraggableTreeviewNode>
      </li>
    </draggable>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import DraggableTreeviewNode from './DraggableTreeviewNode.vue'

export default {
  name: 'DraggableTreeview',
  components: {
    draggable,
    DraggableTreeviewNode,
  },
  props: {
    project: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      items: this.project,
    }
  },
  watch: {
    project(newVal) {
      this.items = newVal
    },
  },

  methods: {
    handleUpdate() {
      this.$emit('update-project', this.items)
      this.$emit('modified')
    },
  },
}
</script>

<style scoped>
.custom-treeview {
  /* background-color: #f5f5f5; */
  border: 1px solid #ddd;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 10px;
}
</style>
